import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import Pagination from '../../../../components/pagination/Pagination'
import ViewOnboardingRequest from './ViewOnboardingRequest'

function OnboardingRequests() {
  const { notify } = useGlobalContext()
  const [customersList, setCustomersList] = useState<any>({ data: [] })
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [showRequest, setShowRequest] = useState<any>(null)

  function fetchOnboardingRequests(page: number, pageSize: number) {
    setBookingsLoading(true)
    let url = ''
    if (search) {
      url = `admin/onboarding-requests/fetch?search=${search}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/onboarding-requests/fetch?page=${page}&limit=${pageSize}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setCustomersList(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }

  useEffect(() => {
    fetchOnboardingRequests(1, 10)
  }, [])

  return (
    <div className='home'>
      {showRequest && (
        <ViewOnboardingRequest
          showRequest={showRequest}
          setShowRequest={setShowRequest}
          fetchOnboardingRequests={fetchOnboardingRequests}
        />
      )}
      <div className='home_tables'>
        <div className='left'>
          {bookingsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              <div className='flex justify-between items-center search-btns flex-wrap'>
                <div className='search flex flex-wrap'>
                  <input
                    type='search'
                    name=''
                    id=''
                    value={search}
                    placeholder='search by name or tracking Id'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />{' '}
                  <button
                    onClick={() => {
                      fetchOnboardingRequests(1, 10)
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
              {customersList.data.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {customersList.data.map((data: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => setShowRequest(data)}
                        key={data._id}
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Full Name</h4>
                          <p>
                            {data.firstname} {data.lastname}
                          </p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>company name</h4>
                          <p>{data.company_name}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Phone</h4>
                          <p>{data.phonenumber}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Email</h4>
                          <p>{data.email}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Full Name</th>
                        <th>Company name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {customersList.data.map((data: any, i: number) => (
                        <tr key={data._id}>
                          <td>{i + 1}</td>
                          <td onClick={() => setShowRequest(data)}>
                            {data.firstname} {data.lastname}
                          </td>
                          <td
                            onClick={() => setShowRequest(data)}
                            className='count'
                          >
                            {data.company_name}
                          </td>
                          <td className='count'>{data.phonenumber}</td>
                          <td className='count'>{data.email}</td>
                          <td className='count'>
                            <span className={data.status}>{data.status}</span>
                          </td>
                          <td className='icons dif'>
                            <span
                              className='PU'
                              onClick={() => setShowRequest(data)}
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    className='pagination-bar'
                    currentPage={customersList.pagination.page}
                    totalCount={customersList.pagination.totalPages}
                    pageSize={customersList.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchOnboardingRequests(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Bookings To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default OnboardingRequests
